import { readable, writable } from 'svelte/store';
import Papa from 'papaparse';
import dayjs from 'dayjs';

const defaultParams = {
  download: true,
  dynamicTyping: true,
  header: true,
  skipEmptyLines: true
};

export const currentPath = writable(window.location.pathname);

const vaccinationsDemographicsStore = readable(null, (set) => {
  Papa.parse(
    '../data/COVID19_vaccination_agegroups_v202210.csv?v=' + dayjs().format('YYYY-MM-DD-hh-mm'),
    {
      ...defaultParams,
      complete: function (results) {
        if (results) {
          set(results.data);
        }
      }
    }
  );
});


const timelineVaccinationsMunicipalitiesStore = readable(null, (set) => {
  Papa.parse(
    '../data/COVID19_vaccination_municipalities_v202210.csv?v=' + dayjs().format('YYYY-MM-DD-hh-mm'),
    {
      ...defaultParams,
      complete: function (results) {
        if (results) {
          set(results.data);
        }
      }
    }
  );
});

const timelineDosesStore = readable(null, (set) => {
  Papa.parse(
    '../data/COVID19_vaccination_timeline_v202210.csv?v=' + dayjs().format('YYYY-MM-DD-hh-mm'),
    {
      ...defaultParams,
      complete: function (results) {
        if (results) {
          set(results.data);
        }
      }
    }
  );
});

const populationStore = readable(null, (set) => {
  Papa.parse(
    '../data/agegroups.csv?v=' + dayjs().format('YYYY-MM-DD-hh-mm'),
    {
      ...defaultParams,
      complete: function (results) {
        if (results) {
          set(results.data);
        }
      }
    }
  );
});


export {
  vaccinationsDemographicsStore,
  timelineVaccinationsMunicipalitiesStore,
  timelineDosesStore,
  populationStore
};